module.exports = __webpack_public_path__ + "static/media/logo.c725c117.png";